const Url = (props) => {
  if (!props || !props.record || !props.record.fileUrl)
    return null

  return <a href={props.record.fileUrl} target="_blank" rel="noreferrer" style={{ color: 'black', fontFamily: 'Gothic', width: '100px', height: '100px' }} >Documento</a>;
};

export default Url;